import type { NavigationGuard } from 'vue-router'
import { useToken } from '@/shared/composables/useToken'
import { PROMOTIONS } from '@/shared/constants/common.constants'
import { EPage } from '@/shared/enum/page.enum'
import { useAppStore } from '@/stores/app'
import { ECountry } from '@/shared/enum/country.enum'

export const promotionGuard: NavigationGuard = async (_to, _from, next) => {
  const appStore = useAppStore()
  const { campaign } = useToken()

  // Dejarle el next()
  if (PROMOTIONS.includes(campaign.value.toUpperCase()) && appStore.country === ECountry.SV)
    return next()

  next({ name: EPage.LANDING })
}
